const faqData = [
  {
    q: 'UU漫画支持哪些连载漫画的更新提醒？',
    a: 'UU漫画覆盖热血、恋爱、悬疑、奇幻、搞笑、科幻、恐怖、日常等全品类连载漫画。只要是你正在追更的漫画，都可以设置更新提醒，最新漫画更新第一时间通知你，追漫必备功能完全免费使用。',
  },
  {
    q: '漫画更新提醒是如何工作的？',
    a: '当你在UU漫画关注某部连载漫画后，该漫画发布新章节时系统会自动推送更新通知。无论是周更、月更还是不定时更新的漫画，漫画更新提醒都会帮你追踪，确保不再错过任何章节。',
  },
  {
    q: 'UU漫画上的漫画资源需要付费吗？',
    a: 'UU漫画提供免费漫画全集阅读服务，所有收录的连载漫画均可免费追更。我们致力于打造追更漫画的免费平台，让每一位漫迷都能无障碍享受最新漫画更新。',
  },
  {
    q: '如何快速找到我想追的漫画？',
    a: '你可以通过首页的漫画索引按品类浏览，也可以使用搜索功能直接输入漫画名称。追更榜单会展示当前热度最高的最新漫画更新，帮助你发现热门连载漫画。',
  },
  {
    q: 'UU漫画支持移动端使用吗？',
    a: '当然支持！UU漫画针对手机端进行了全面适配，你可以在浏览器中直接访问。移动追漫体验流畅，随时随地查看连载漫画的最新更新，追漫必备的移动端入口已为你准备好。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '不同连载漫画的更新频率各不相同，有周更、双周更、月更等。UU漫画会实时追踪各漫画源的更新状态，确保最新漫画更新内容在第一时间同步到平台，每日都有新内容可追。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于漫画追更与最新漫画更新，你想知道的都在这里
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqData.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6">
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-800 mb-3 flex items-start gap-3">
                <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-xs font-black">Q</span>
                </span>
                {item.q}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed pl-9">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}